import { Component, Inject } from '@angular/core';
import { MODAL_SIZES } from '@edassist-ui/modal';
import { BUTTON_TYPES } from '@edassist-ui/button';
import {
	constants,
	ParticipantUtilityService,
	LiveChatUtilityService,
	SiteMapLinkService,
	WINDOW,
	GoogleTagManagerEventService
} from '@edassist/common';
import { AuthenticationService } from '@edassist/api';
import { ModalService } from '@edassist/shared';
import { DropdownService } from '@edassist-ui/dropdown';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ea-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
	constants = constants;
	MODAL_SIZES = MODAL_SIZES;
	BUTTON_TYPES = BUTTON_TYPES;
	private readonly subscriptions = new Subscription();

	constructor(
		@Inject(WINDOW) private readonly window: Window,
		private readonly router: Router,
		private readonly authService: AuthenticationService,
		private readonly modalService: ModalService,
		private readonly liveChatUtilityService: LiveChatUtilityService,
		private readonly siteMapLinkService: SiteMapLinkService,
		private readonly dropdownService: DropdownService,
		private readonly gtmEventService: GoogleTagManagerEventService
	) {
		this.subscriptions.add(
			siteMapLinkService.logout.subscribe(() => {
				this.openConfirmModal();
			})
		);
	}

	openConfirmModal(): void {
		this.dropdownService.close(constants.dropdownIds.profileActions);
		this.modalService.openModal(constants.modalIds.LOGOUT_CONFIRMATION);
	}

	logout(): void {
		const ssoEnabled = ParticipantUtilityService.getClientLoginDetails()?.ssoEnabled;
		const ssoLogOffEnabled = ParticipantUtilityService.getClientLoginDetails()?.ssoLogoffEnabled;
		const isConsolidatedLoginEnabled = ParticipantUtilityService.getClientLoginDetails()?.consolidatedLoginEnabled;
		const consolidatedLogoutUrl = ParticipantUtilityService.getClientLoginDetails()?.consolidatedLoginLogoutURL;

		this.liveChatUtilityService.removeChatBox();

		this.gtmEventService.sendLogout(
			constants.googleAnalytics.benefit.id,
			constants.googleAnalytics.benefit.source,
			undefined,
			undefined
		);

		if (ssoEnabled) {
			this.router.navigate([constants.routes.SSO_LOGOUT], {
				queryParams: { ssoLogOffEnabled }
			});
		} else if (isConsolidatedLoginEnabled && consolidatedLogoutUrl) {
			this.authService.hybridAppLogout(false, true, consolidatedLogoutUrl);
		} else {
			this.authService.hybridAppLogout();
		}
	}

	cancel(): void {
		this.modalService.closeModal(this.constants.modalIds.LOGOUT_CONFIRMATION);
	}
}
